const $$splitComponentImporter = () => import('/opt/buildhome/repo/src/routes/farmso/dashboard/supply.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/farmso/dashboard/supply')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});